import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {take} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {AppState} from '../../../store/app-state';
import {CommonService} from '../../../services/common.service';

@Component({
  selector: 'app-announcement',
  templateUrl: './announcement.component.html',
  styleUrls: ['./announcement.component.less'],
  animations: [
    trigger('openClose', [
      state('void', style({
        height: 0,
        'margin-bottom': 0,
        opacity: 0,
      })),
      transition('* => void', animate(200)),
    ])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnnouncementComponent implements OnInit {

  closed = false;
  ads: any;

  constructor(private store: Store<{ app: AppState }>, private commonService: CommonService) { }

  ngOnInit(): void {
    this.store.select('app', 'commonData')
      .pipe(take(1))
      .subscribe(commonData => {
        if (commonData) {
          this.ads = commonData?.news_data?.ad;
          this.commonService.setFullPageLoaderVisibility(false);
        }
      });
  }

  closeNews(): void {
    this.closed = true;
  }

}
